/**
 * rb-review-count.js
 *
 * Product cards were showing "1 review" instead of "(1)" on mobile.
 *
 * Cause: `product.metafields.judgeme.badge` renders the badge server-side with
 * Judge.me's default wording ("1 review" / "3 reviews"). Judge.me's own script
 * later rewrites that text to the configured "(n)" format — on desktop it lands
 * before you notice, on mobile it's often visibly late or doesn't run at all.
 *
 * Fix: set the text ourselves from the badge's own `data-number-of-reviews`,
 * immediately and again whenever grids re-render (filters, pagination, quick
 * add). Idempotent — if Judge.me already wrote "(n)" this changes nothing.
 */
(function () {
  'use strict';

  var SEL = '.jdgm-prev-badge';

  function normalize(badge) {
    if (!badge) return;
    var textEl = badge.querySelector('.jdgm-prev-badge__text');
    if (!textEl) return;

    var n = badge.getAttribute('data-number-of-reviews');
    if (n === null || n === '') return;

    var count = parseInt(n, 10);
    if (isNaN(count)) return;

    // Judge.me hides the whole badge for zero-review products; respect that.
    if (count <= 0) return;

    var want = '(' + count + ')';
    if (textEl.textContent.trim() !== want) textEl.textContent = want;
  }

  function run(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var badges = scope.querySelectorAll(SEL);
    [].forEach.call(badges, normalize);
  }

  function init() {
    run(document);

    // Grids re-render on filter/pagination, and Judge.me hydrates async —
    // catch both without re-scanning the whole document every time.
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'characterData') {
          var host = m.target.parentElement && m.target.parentElement.closest
            ? m.target.parentElement.closest(SEL)
            : null;
          if (host) normalize(host);
          continue;
        }
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches(SEL)) normalize(node);
          else run(node);
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    // Judge.me can hydrate after load; a couple of cheap re-runs cover it.
    setTimeout(function () { run(document); }, 1200);
    setTimeout(function () { run(document); }, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
